import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgLearn = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 17 16"
    ref={ref}
    {...props}
  >
    <path
      fill="#AEAEAE"
      d="M14.875 3h-4.5a2.5 2.5 0 0 0-2 1 2.5 2.5 0 0 0-2-1h-4.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h4.5a1.5 1.5 0 0 1 1.5 1.5.5.5 0 0 0 1 0 1.5 1.5 0 0 1 1.5-1.5h4.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5m-8.5 9h-4V4h4a1.5 1.5 0 0 1 1.5 1.5v7a2.5 2.5 0 0 0-1.5-.5m8 0h-4c-.541 0-1.068.175-1.5.5v-7a1.5 1.5 0 0 1 1.5-1.5h4zm-4-6.5h2.5a.5.5 0 0 1 0 1h-2.5a.5.5 0 0 1 0-1m3 2.5a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .5.5m0 2a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .5.5"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLearn);
export default ForwardRef;
